/**
 * Track Form View Event
 */

import { logDebug, pushToAdobeDataLayer } from './utils';

export interface FormViewParams {
    /** Form type (e.g., 'contact') */
    type: string;
    /** Form name (e.g., 'General Contact Request') */
    name: string;
    /** Form destination (e.g., 'contact form endpoint') */
    destination: string;
}

/**
 * Track a form view event
 */
export const trackFormView = async ({
    type,
    name,
    destination,
}: FormViewParams): Promise<void> => {
    logDebug('Tracking form view...');
    const payload = {
        event: 'formView',
        _volvo: {
            universal: {
                web: {
                    form: {
                        type,
                        name,
                        destination,
                        formView: {
                            value: 1,
                        },
                    },
                },
            },
        },
        web: {
            webInteraction: {
                type: 'other',
            },
        },
    };
    await pushToAdobeDataLayer(payload);
};
